<template>
    <section class="content">
        <box>
            <div slot="body">
                <div class="row">
                    <div class="col-md-11">
                        <input class="form-control" placeholder="Descrição ..." type="text" v-model="filter">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <router-link class="pageLink" to="/nova-condpagto">
                        <br><br>
                        <button class="btn btn-primary" >Nova Condição de Pagamento</button>
                        </router-link>
                    </div>
                </div>  
            </div>
        </box>
        <box>
            <div slot="body">
                <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                    <div class="col-sm-6">
                    <div id="example1_length" class="dataTables_length">

                    </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 table-responsive" id="table">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                        <thead>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderCondPagto(coluna)" >{{coluna | ucwords}}</a>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="even" role="row" v-for="p in condPagtoFiltered">
                            <td>{{p.id}}</td>
                            <td class="sorting_1">{{p.nome}}</td>
                            <td>
                                <button class="btn btn-danger " @click="excluir(p.id)">Excluir</button>
                            </td>
                        </tr>
                                                
                        </tbody>
                        <tfoot>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderCondPagto(coluna)">{{coluna | ucwords}}</a>
                            </th>
                        </tr>
                        </tfoot>
                    </table>
                    </div>
                </div>
                </div>
                        <!-- /.box-body -->
            </div>
        </box>

    </section>
</template>
<script>
import axios from 'axios'
import Modal from './Modal' // importando modal
import Box from './Box'


export default {
  name: 'CondPagto',
  components: {
    'modal': Modal,
    'box': Box
  },
  data() {
      return {
        condpagto: '',
        order: {
            keys: '',
            sort: ''
        },
        colunas: ['id', 'nome'],
        filter: '',
      }
  },
  created() {
      this.getProducts()
  },
  methods: {
      getProducts () {
      axios.get(`${this.$store.state.api}pagamentos?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.condpagto = response.data
      })
    },
    excluir (id) {
      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
            axios.post(this.$store.state.api+'pagamentos/delete', {
                'id': id,
            }).then(response => {
                if(response.data.success === 'true'){
                    for (var i = 0; i < this.condpagto.length; i++) {
                        if (id === this.condpagto[i].id) {
                            this.condpagto.splice(i, 1)
                        }
                    }
                    this.$swal({
                        position: 'top-end',
                        type: 'success',
                        title: 'Condição de Pagamento Deletada',
                        showConfirmButton: false,
                        timer: 1500
                    })
                } else {
                    this.$swal(
                        'Ops!',
                        'Não foi possivel deletar o pagamento.',
                        'error'
                    )
                }
            })
        } else {
            this.$swal(
                'Ops!',
                'Não foi possivel deletar o pagamento.',
                'error'
            )
            }
        })
    },
    orderCondPagto (coluna) {
        this.order.keys = coluna
        //   console.log(this.order.keys)
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
        //   console.log(this.order.sort)
    }
  },
  filters: {
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    condPagtoFiltered () {
      let colecao = _.orderBy(this.condpagto, this.order.keys, this.order.sort)
      return _.filter(colecao, item => {
        return item.nome.indexOf(this.filter) >= 0
      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// CondPagto.vue?0b7b1d4c